module.exports = __webpack_public_path__ + "img/integral-bg2.11e82454.png";